export const harvestType = [
  {
    label: "Field Prep",
    value: "field_Prep",
  },
  {
    label: "Plant",
    value: "plant",
  },
  {
    label: "Picking ",
    value: "picking ",
  },
  {
    label: "Weeding",
    value: "weeding",
  },
  {
    label: "Spraying",
    value: "spraying",
  },
  {
    label: "Other",
    value: "other",
  },
];
